import { lazy } from "react";

export const BCHome = lazy(() => import("./Home/Home"));
export const BCPlainWrapper = lazy(
  () => import("Pages/Skeleton/Blockchain/PlainWrapper/PlainWrapper"),
);
export const LeaseAgreement = lazy(
  () => import("./LeaseAgreement/LeaseAgreement"),
);
export const PropertyCheckout = lazy(
  () =>
    import("Pages/Frontend/Interface/Blockchain/Interface/EstateManager/Interface/PropertyCheckout/PropertyCheckout"),
);
export const BCPropertyDetails = lazy(
  () =>
    import("Pages/Frontend/Interface/Blockchain/Interface/EstateManager/Interface/PropertyDetails/PropertyDetails"),
);
